import {Component}        from '@angular/core';
import {TranslateService} from "@ngx-translate/core";

const VERTAGE_NEWS_URL = 'https://www.vertage.com/resources/news/headfirst-global-becomes-vertage-work-orchestration-platform';

// The translations are hardcoded because the i18n files live on S3.
const TEXTS: Record<string, { poweredBy: string, findOutMore: string }> = {
    nl: {poweredBy: 'Striive nu powered by', findOutMore: 'Meer lezen'},
    en: {poweredBy: 'Striive now powered by', findOutMore: 'Find out more'},
};

// Hidden until the Vertage cut-over, see the inline script in index.html and styles.scss.
@Component({
    selector   : 'app-vertage-banner',
    standalone : true,
    templateUrl: './vertage-banner.component.html',
})
export class VertageBannerComponent {
    readonly url = VERTAGE_NEWS_URL;

    constructor(private readonly translateService: TranslateService) {
    }

    get texts() {
        return TEXTS[this.translateService.currentLang] ?? TEXTS['nl'];
    }
}
